import React, {useState, useEffect, useRef} from 'react';
import AsyncCreatableSelect from 'react-select/async-creatable';
import AsyncSelect from 'react-select/async';

import axios from 'axios';

export const AutocompleteCustomHybrid = ({ onPlaceSelect, locationBias, locationBiasRadius, countyRestriction, customSearchAllowed, selectedValue, setSelectedValue }) => {
    const [places, setPlaces] = useState();
    const [menuIsOpen, setMenuIsOpen] = useState(false);
    const [locationBiasObject, setLocationBiasObject] = useState(null);
    const sessionTokenRef = useRef(null);
    const selectInputRef = useRef();

    const resetSession = () => {
        sessionTokenRef.current = null;
    }
    useEffect(() => {
        if (!window.google || !window.google.maps) {
            (g => { var h, a, k, p = "The Google Maps JavaScript API", c = "google", l = "importLibrary", q = "__ib__", m = document, b = window; b = b[c] || (b[c] = {}); var d = b.maps || (b.maps = {}), r = new Set, e = new URLSearchParams, u = () => h || (h = new Promise(async (f, n) => { await (a = m.createElement("script")); e.set("libraries", [...r] + ""); for (k in g) e.set(k.replace(/[A-Z]/g, t => "_" + t[0].toLowerCase()), g[k]); e.set("callback", c + ".maps." + q); a.src = `https://maps.${c}apis.com/maps/api/js?` + e; d[q] = f; a.onerror = () => h = n(Error(p + " could not load.")); a.nonce = m.querySelector("script[nonce]")?.nonce || ""; m.head.append(a) })); d[l] ? console.warn(p + " only loads once. Ignoring:", g) : d[l] = (f, ...n) => r.add(f) && u().then(() => d[l](f, ...n)) })({
                key: process.env.REACT_APP_GOOGLE_MAPS_KEY,
                v: "weekly",
            });
        }
        importLibrary();
    }, []);

    useEffect(() => {
        if (locationBias) { 
            axios.get(`https://maps.googleapis.com/maps/api/geocode/json?address=${locationBias}&key=${process.env.REACT_APP_GOOGLE_MAPS_KEY}`)
			.then((response) => {
                setLocationBiasObject({ center: { lat: response.data.results[0].geometry.location.lat, lng: response.data.results[0].geometry.location.lng }, radius: locationBiasRadius });
			});
            
        }
    }, [locationBias, locationBiasRadius]);

    async function importLibrary() {
        var lib = await window.google.maps.importLibrary('places');
        setPlaces(lib);
    }

    const handleSuggestionClick = async (suggestion) => {
        if (!places) return;
        if (!suggestion.placePrediction) return;
        const place = suggestion.placePrediction.toPlace();
        await place.fetchFields({
          fields: ["addressComponents", "formattedAddress"],
        });
        resetSession();
        setMenuIsOpen(false);
        setSelectedValue(place.formattedAddress);
        onPlaceSelect(place.formattedAddress);
    }

    async function makeAutocompleteRequest(inputText, callback) {
        if (!places) return;
        const {AutocompleteSessionToken, AutocompleteSuggestion} = places;
        if (!sessionTokenRef.current) {
            sessionTokenRef.current = new AutocompleteSessionToken();
        }
        const request = {
            input: inputText,
            locationBias: locationBiasObject,
            language: 'en-US',
            region: 'us',
            sessionToken: sessionTokenRef.current

        };
        const { suggestions } = await AutocompleteSuggestion.fetchAutocompleteSuggestions(request);
        var mappedSuggestions = [];
        for (var suggestion of suggestions) {
            if (!countyRestriction || await suggestionIsInCounty(suggestion)) mappedSuggestions.push({ value: suggestion, label: suggestion.placePrediction.text.toString() });
        }
        callback(mappedSuggestions);
    }

    const suggestionIsInCounty = async (suggestion) => { 
        const place = suggestion.placePrediction.toPlace();
        await place.fetchFields({
          fields: ["addressComponents"],
        });
        var county = place.addressComponents.find(t => t.types.includes("administrative_area_level_2"))?.shortText.replace(' County', '').toLowerCase();
        return county === countyRestriction.toLowerCase();
    }

    const handleInputChange = (input) => {
        if (input === '') {
            setMenuIsOpen(false);
        } else if (!menuIsOpen) { 
            setMenuIsOpen(true);
        }
    }

  return (
       customSearchAllowed ? <AsyncCreatableSelect
          loadOptions={makeAutocompleteRequest}
          onChange={(e, type) => { if (type.action === 'clear') { setSelectedValue('') } else { e && handleSuggestionClick(e.value) } }}
          ref={selectInputRef}
          placeholder="Start typing to search"
          onClick={() => { selectInputRef.current && selectInputRef.current.clearValue() }}
          isClearable={true}
          formatCreateLabel={(input) => { return "Search for '" + input + "'" }}
          onCreateOption={(input) => { setMenuIsOpen(false); setSelectedValue(input); onPlaceSelect(input) }}
          onFocus={() => { setSelectedValue(''); }}
          value={{ label: selectedValue }}
          menuIsOpen={menuIsOpen}
          onInputChange={handleInputChange}       
          /> :
          <AsyncSelect 
              loadOptions={makeAutocompleteRequest}
              onChange={(e, type) => { if (type.action === 'clear') { setSelectedValue('') } else { e && handleSuggestionClick(e.value) } }}
              ref={selectInputRef}
              placeholder="Start typing to search"
              onClick={() => { selectInputRef.current && selectInputRef.current.clearValue() }}
              isClearable={true}
              onFocus={() => { setSelectedValue(''); }}
              value={{ label: selectedValue }}
              menuIsOpen={menuIsOpen}
              onInputChange={handleInputChange}      
          />
  );
};